/*
  „Kje si nas našel?"

  Edino vprašanje, ki pove, ali se oglaševanje izplača. Brez njega ostane
  merjenje pri všečkih, ti pa ne veš, ali je tečajnik prišel iz oglasa, ki si
  ga plačal, ali od soseda, ki mu je bilo pri tebi lepo.

  Vprašanje je NAMENOMA neobvezno. Kdor noče odgovoriti, naj klikne naprej —
  vsiljena izbira da lažen podatek, ne boljšega.
*/

export const VIRI = [
  { key: 'tandem', label: 'Bil sem na tandem poletu pri vas' },
  { key: 'priporocilo', label: 'Priporočil mi je znanec' },
  { key: 'google', label: 'Našel sem vas na Googlu' },
  { key: 'druzbena', label: 'Facebook ali Instagram' },
  { key: 'spletna', label: 'Spletna stran perut.net' },
  { key: 'dogodek', label: 'Dogodek, sejem ali vzletišče' },
  { key: 'drugo', label: 'Drugo' },
];

const PO_KLJUCU = Object.fromEntries(VIRI.map((v) => [v.key, v.label]));

export function virLabel(key) {
  return PO_KLJUCU[key] ?? null;
}

/**
 * Seštevek po virih. Vrne vrstice, urejene po pogostosti, in ločeno število
 * tistih, ki niso odgovorili — ta številka je pomembna, ker pove, koliko je
 * celotni pregled vreden.
 *
 * `leto` je letnica datuma tečaja; kdor ga nima vpisanega, pade pod `null`.
 */
export function povzetekVirov(profiles = [], { leto = null } = {}) {
  const v = profiles.filter((p) => !p?.testni && !p?.archived);
  const izbrani = leto === null ? v : v.filter((p) => letoTecaja(p) === leto);

  const stevci = new Map();
  let brezOdgovora = 0;

  izbrani.forEach((p) => {
    const k = p?.vir_prihoda;
    if (!k || !PO_KLJUCU[k]) {
      brezOdgovora += 1;
      return;
    }
    stevci.set(k, (stevci.get(k) ?? 0) + 1);
  });

  const odgovorilo = izbrani.length - brezOdgovora;

  const vrstice = [...stevci.entries()]
    .map(([key, n]) => ({
      key,
      label: PO_KLJUCU[key],
      n,
      // Delež med tistimi, ki so odgovorili — deliti s celoto bi vse
      // vire potlačilo sorazmerno s tem, koliko ljudi je vprašanje preskočilo.
      delez: odgovorilo ? Math.round((n / odgovorilo) * 100) : 0,
    }))
    .sort((a, b) => b.n - a.n || a.label.localeCompare(b.label, 'sl'));

  return { skupaj: izbrani.length, odgovorilo, brezOdgovora, vrstice };
}

/** Letnica datuma tečaja, ali null. */
export function letoTecaja(p) {
  const d = p?.datum_tecaja;
  if (!d) return null;
  const leto = Number(String(d).slice(0, 4));
  return Number.isFinite(leto) && leto > 1900 ? leto : null;
}

/** Letnice, za katere sploh imamo tečajnike — najnovejša prva. */
export function letaTecajev(profiles = []) {
  const s = new Set();
  profiles
    .filter((p) => !p?.testni && !p?.archived)
    .forEach((p) => {
      const l = letoTecaja(p);
      if (l !== null) s.add(l);
    });
  return [...s].sort((a, b) => b - a);
}
